import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { FirestorePathsService } from './firestorePaths.service';
import { FirestoreService } from '../lib/firestore.service';

import type {
    TCustomer
} from '@shared/models';

@Injectable({
    'providedIn': 'root'
})
export class CustomersService {
    constructor(private firestoreService: FirestoreService, private firestorePathsService: FirestorePathsService) {
    }

    public getObservable(): Observable<TCustomer[]> {
        const path = this.firestorePathsService.getCustomersPath();
        const observable = this.firestoreService.getObservable(path) as Observable<TCustomer[]>;
        return observable;
    }

    public async getByFieldValue(fieldName: string, fieldValue: string): Promise<TCustomer[]> {
        const path = this.firestorePathsService.getCustomersPath();
        return this.firestoreService.getByFieldValue(path, fieldName, fieldValue) as Promise<TCustomer[]>;
    }

    public async getByUid(uid: string): Promise<TCustomer> {
        const path = this.firestorePathsService.getCustomersPath();
        return this.firestoreService.getByUid(path, uid) as Promise<TCustomer>;
    }

    public async getAll(): Promise<TCustomer[]> {
        const path = this.firestorePathsService.getCustomersPath();
        return this.firestoreService.getAll(path) as Promise<TCustomer[]>;
    }

    public async add(customer: TCustomer): Promise<TCustomer> {
        const path = this.firestorePathsService.getCustomersPath();
        return this.firestoreService.add(path, customer) as Promise<TCustomer>;
    }

    public async set(customer: TCustomer): Promise<TCustomer> {
        customer.uid = customer.cellPhone;
        const path = this.firestorePathsService.getCustomersPath();
        await this.firestoreService.set(path, customer);
        return customer;
    }

    public async update(customer: TCustomer): Promise<TCustomer> {
        const path = this.firestorePathsService.getCustomersPath();
        return this.firestoreService.update(path, customer) as Promise<TCustomer>;
    }

    public async delete(uid: string): Promise<void> {
        const path = this.firestorePathsService.getCustomersPath();
        return this.firestoreService.delete(path, uid);
    }

    // public getByAccountNumber(accountNumber: string): Promise<TCustomer> {
    //     const collection = this.firestorePathsService.getCustomerColByAccountNumber(accountNumber);
    //     return this.firestoreService.getAll(collection);
    // }

    // public getByAccountNumber(accountNumber: string): Promise<TCampaignIncentive[]> {
    //     const collection = this.firestorePathsService.getCampaignIncentivesColByAccountNumber(accountNumber);
    //     return this.firestoreService.getAll(collection);
    // }

    // Check to see if this method is called and needed.
    // public async getCustomer(accountNumber: string, customerUid: string): Promise<TCustomer> {
    //     console.error('customersService.getCustomer() method has not been is incomplete.');
    //     const collection = this.firestorePathsService.getCustomerColByAccountNumber(accountNumber);
    //     return this.firestoreService.getByUid(collection, customerUid) as Promise<TCustomer>;
    //     // return this.getByUid(customerUid);
    // }

    public sortCustomers(customers: TCustomer[]): TCustomer[] {
        const sortedCustomers = customers.sort((a, b) => {
            // return a.localCompare(b);    // localCompare doesn't exist, so do the compare ourselves
            if (a.customerName < b.customerName) {
                return -1;
            } else if (a.customerName > b.customerName) {
                return 1;
            } else {
                return 0;
            }
        });

        return sortedCustomers;
    }
}
